$(document).on('turbolinks:before-visit turbolinks:click', function() {
  if (window.AxePageLoader) {
    window.AxePageLoader.show();
  } else {
    $('#loading').removeClass('is-hidden');
  }
});
